import { ReportsLayout } from './reports-layout';
import { AnalyticsDashboardPage } from './analytics-dashboard-page';
import { StandardReportsPage } from './standard-reports-page';
import { CustomReportsPage } from './custom-reports-page';
import { ScheduledReportsPage } from './scheduled-reports-page';
import { SustainabilityMetricsPage } from './sustainability-metrics-page';

export const reportsRoutes = [
  {
    path: 'reports',
    element: <ReportsLayout />,
    children: [
      {
        path: 'analytics',
        element: <AnalyticsDashboardPage />
      },
      {
        path: 'standard',
        element: <StandardReportsPage />
      },
      {
        path: 'custom',
        element: <CustomReportsPage />
      },
      {
        path: 'scheduled',
        element: <ScheduledReportsPage />
      },
      {
        path: 'sustainability',
        element: <SustainabilityMetricsPage />
      }
    ]
  }
]; 